import {faAngleLeft, faAngleRight, faAnglesLeft, faAnglesRight} from "@fortawesome/free-solid-svg-icons";
import FlintIconButton from "@components/controls/FlintIconButton";
import {useTranslation} from "react-i18next";
import styles from "./RecipeVersionPager.module.scss";

export interface RecipeVersionPagerProps {
    viewingVersionNumber: number | null;
    latestVersionNumber: number;
    onNavFirst: () => void;
    onNavPrev: () => void;
    onNavNext: () => void;
    onNavLatest: () => void;
}

export default function RecipeVersionPager(props: RecipeVersionPagerProps) {
    const {t} = useTranslation();
    const {viewingVersionNumber, latestVersionNumber, onNavFirst, onNavPrev, onNavNext, onNavLatest} = props;

    const displayNumber = viewingVersionNumber ?? latestVersionNumber;
    const canFirst = viewingVersionNumber !== null ? viewingVersionNumber > 1 : latestVersionNumber > 1;
    const canPrev = canFirst;
    const canNext = viewingVersionNumber !== null;
    const canLatest = viewingVersionNumber !== null;

    return (
        <div className={styles.pager}>
            {canFirst && (
                <FlintIconButton faIcon={faAnglesLeft}
                                 title={t("ORDER_RECIPE_HISTORY_NavFirst")}
                                 onClick={onNavFirst}/>
            )}
            {canPrev && (
                <FlintIconButton faIcon={faAngleLeft}
                                 title={t("ORDER_RECIPE_HISTORY_NavPrev")}
                                 onClick={onNavPrev}/>
            )}
            <span className={styles.counter}>{displayNumber}&nbsp;/&nbsp;{latestVersionNumber}</span>
            {canNext && (
                <FlintIconButton faIcon={faAngleRight}
                                 title={t("ORDER_RECIPE_HISTORY_NavNext")}
                                 onClick={onNavNext}/>
            )}
            {canLatest && (
                <FlintIconButton faIcon={faAnglesRight}
                                 title={t("ORDER_RECIPE_HISTORY_NavLatest")}
                                 onClick={onNavLatest}/>
            )}
        </div>
    );
}
